// extracted by mini-css-extract-plugin
export var checkboxwrapper = "FormCheckbox-module--checkboxwrapper--1456e";
export var checklabel = "FormCheckbox-module--checklabel--7393f";